import React from 'react';
import { DescriptionTypography, SectionContainer, CircleContainer, Circle, CircleTypography, TextContainer, CircleColumn } from '../../styles/EventsPages/EventTypeDescription.style';

interface EventTypeDescriptionSectionProps {
    descriptions: {
        subtitle: string;
        text: string;
        imageUrl: string;
    }[];
}



const EventTypeDescriptionSection: React.FC<EventTypeDescriptionSectionProps> = ({ descriptions }) => {
    return (
      <SectionContainer>
        <CircleContainer>
          {descriptions.map((event, index) => (
            <CircleColumn key={index}>
              <Circle imageUrl={event.imageUrl} aria-label={event.subtitle}>
                <CircleTypography>
                  {event.subtitle}
                </CircleTypography>
              </Circle>
              <TextContainer>
                <DescriptionTypography>
                  {event.text}
                </DescriptionTypography>
              </TextContainer>
            </CircleColumn>
          ))}
        </CircleContainer>
      </SectionContainer>
    )
  }

export default EventTypeDescriptionSection;
